import React from "react";
import {civilEngineeringProjects, mobileAppProjects, webAppProjects} from "../utils/constants";
import {Link} from "react-router-dom";

function ProjectsPage() {
    return (
        <div className="container" id="Projects">
            <div className="hero-block">
                <div className="hero-heading-wrap">
                    <div className="hero-icon">
                        <div className="icon-svg w-embed">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M19.906 9c.382 0 .749.057 1.094.162V9a3 3 0 00-3-3h-3.879a.75.75 0 01-.53-.22L11.47 3.66A2.25 2.25 0 009.879 3H6a3 3 0 00-3 3v3.162A3.756 3.756 0 014.094 9h15.812zM4.094 10.5a2.25 2.25 0 00-2.227 2.568l.857 6A2.25 2.25 0 004.951 21H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-2.227-2.568H4.094z"/>
                            </svg>
                        </div>
                    </div>
                    <h1 className="hero-heading">Projects</h1>
                </div>
                <div className="text-lead">
                    Selected Civil Engineering, Mobile and Web App projects.
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Civil Engineering Projects.</h2>
                    <div className="content-title is-text">Seamlessly integrate your engineering workflows</div>
                </div>
                <div className="w-layout-grid _2x-column">
                    {civilEngineeringProjects.map((item) => (
                        <Link to="#" target="_blank" className="card w-inline-block">
                            <div className="shine-wrap">
                                <div className="shine"></div>
                            </div>
                            <div className="card-content-vertical">
                                <div className="tools">
                                    <div className="tools-head">
                                        <div className="tools-icon">
                                            <div className="image-background"></div>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>
                                            <h2 className="card-heading">{item.title}</h2>
                                        </div>
                                    </div>
                                    <div className="card-text-2-lines">
                                        {item.description}
                                    </div>
                                </div>
                                <div className="card-meta">
                                    <div className="card-info">
                                        {item.tools.map((toolItem) => (
                                            <div className="card-tag">{toolItem.name}</div>
                                        ))}
                                    </div>
                                    <div className="card-cta">
                                        <div className="icon-svg w-embed">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Mobile App Development.</h2>
                    <div className="content-title is-text">Seamlessly integrate your engineering workflows</div>
                </div>
                <div className="w-layout-grid _2x-column">
                    {mobileAppProjects.map((item) => (
                        <a href="#" target="_blank" className="card w-inline-block">
                            <div className="shine-wrap">
                                <div className="shine"></div>
                            </div>
                            <div className="card-content-vertical">
                                <div className="tools">
                                    <div className="tools-head">
                                        <div className="tools-icon">
                                            <div className="image-background"/>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>
                                            <h2 className="card-heading">{item.title}</h2>
                                        </div>
                                    </div>
                                    <div className="card-text-2-lines">
                                        {item.description}
                                    </div>
                                </div>
                                <div className="card-meta">
                                    <div className="card-info">
                                        {item.tools.map((toolItem) => (
                                            <div className="card-tag">{toolItem.name}</div>
                                        ))}
                                    </div>
                                    <div className="card-cta">
                                        <div className="icon-svg w-embed">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 stroke-width="1.5" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
            <div className="block-divider"></div>
            <div className="section-block">
                <div className="content-title-wrap">
                    <div className="content-title-dot"></div>
                    <h2 className="content-title">Web Development.</h2>
                    <div className="content-title is-text">Keep everyone in sync</div>
                </div>
                <div className="w-layout-grid _2x-column">
                    {webAppProjects.map((item) => (
                        <a href="#" target="_blank" className="card w-inline-block">
                            <div className="shine-wrap">
                                <div className="shine"></div>
                            </div>
                            <div className="card-content-vertical">
                                <div className="tools">
                                    <div className="tools-head">
                                        <div className="tools-icon">
                                            <div loading="lazy" sizes="40px" alt="" className="image-background"/>
                                            <div className="app-outline"></div>
                                        </div>
                                        <div>
                                            <h2 className="card-heading">{item.title}</h2>
                                        </div>
                                    </div>
                                    <div className="card-text-2-lines">
                                        {item.description}
                                    </div>
                                </div>
                                <div className="card-meta">
                                    <div className="card-info">
                                        {item.tools.map((toolItem) => (
                                            <div className="card-tag">{toolItem.name}</div>
                                        ))}
                                    </div>
                                    <div className="card-cta">
                                        <div className="icon-svg w-embed">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 stroke-width="1.5" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                      d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ProjectsPage